
import exitPopupThemeTemplate from '../../templates/exit_popup/RDTheme/exitpopup_template.ejs'
import exitPopupRDPlusThemeTemplate from '../../templates/exit_popup/RDPlusTheme/exitpopup_template.ejs'

// message template
import exitPopupMessageTemplate from '../../templates/exit_popup/RDTheme/message_template.ejs'
import exitPopupMessageRDPlusThemeTemplate from '../../templates/exit_popup/RDPlusTheme/message_template.ejs'


const ImportEPTemplateFactory = (options) => {
    const defaultTemplates = {
        exitPopupThemeTemplate,
        exitPopupMessageTemplate
    };

    const rdPlusTemplates = {
        exitPopupThemeTemplate: exitPopupRDPlusThemeTemplate,
        exitPopupMessageTemplate: exitPopupMessageRDPlusThemeTemplate
    };

    if (ApexChat.IsRoundedDynamicPlusTheme) {
        return rdPlusTemplates;
    }

    return defaultTemplates;
}
export default ImportEPTemplateFactory;
